<template>
  <div class="infoClass">
    <div class="brumd_view">
      <div class="brumd_card">
        <span @click="homeBack">首页</span>
        > {{ keyword }}
      </div>
      <!--  -->
      <div class="brumdSearch">
        <slot></slot>
      </div>
    </div>
    <div style="padding: 20px">
      <SearchList :infoList="infoList" :toPath="toPath"></SearchList>
      <div style="text-align: center; margin: 20px 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          :layout="layout"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { apiRequest } from "@/api/api.js";
import SearchList from "../../../components/searchList.vue";
export default {
  components: {
    SearchList,
  },
  data() {
    return {
      keyword: "",
      infoList: [],
      pageTitle: "",
      inputValue: "",
      currentPage: 1,
      totalNum: 0,
      pageSize: 10,
      toPath: "videoplay",
      layout: "total, sizes, prev, pager, next, jumper",
    };
  },
  watch: {
    $route: {
      handler(to) {
        const { keyword } = to.query;
        if (keyword) {
          this.keyword = keyword;
          this.getInformation(keyword);
        }
      },
      deep: true,
    },
  },
  created() {
    const { keyword } = this.$route.query;
    if (keyword) {
      this.keyword = keyword;
      this.getInformation(keyword);
    }
  },
  mounted() {
    if (this.$phoneSize()) {
      this.toPath = "phoneVideoplay";
      this.layout = "prev, pager, next";
    } else {
      this.toPath = "videoplay";
      this.layout = "total, sizes, prev, pager, next, jumper";
    }
  },
  methods: {
    // 回到首页
    homeBack() {
      const screenWidth = window.screen.width;
      if (screenWidth < 760) {
        this.$router.replace("/phone");
      } else {
        this.$router.replace("/");
      }
    },
    // 获取栏目资讯列表
    async getInformation(key_word) {
      await apiRequest({
        method: "get",
        url: "/app-api/website/news/get-video-news",
        data: {
          key_word,
          pageNo: this.currentPage,
          pageSize: this.pageSize,
        },
        success: (res) => {
          if (res.data && res.data.list && res.data.list.length > 0) {
            this.infoList = res.data.list;
            this.totalNum = parseInt(res.data.total);
          } else {
            this.infoList = [];
            this.totalNum = 0;
          }
        },
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getInformation(this.keyword);
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getInformation(this.keyword);
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .infoClass {
    min-height: 720px;
    background-color: #fff;
    width: 100%;
    margin: 10px 0;
  }
}

@media screen and (min-width: 750px) {
  .infoClass {
    min-height: 710px;
    background-color: #fff;
    width: 1200px;
    margin: 10px auto;
  }
}
@media screen and (max-width: 750px) {
  .brumd_view {
    border-bottom: 2px solid #f5f5f5;
    display: flex;
    flex-flow: column;
  }
  .brumdSearch {
    padding: 10px 20px;
  }
}
@media screen and (min-width: 750px) {
  .brumd_view {
    border-bottom: 2px solid #f5f5f5;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.brumd_card {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  padding-left: 20px;
  box-sizing: border-box;
}

.brumd_card span {
  cursor: pointer;
}
</style>
